module.exports = __webpack_public_path__ + "static/media/castle-pass.ab994675.png";